import Language from './language';

export default class Control_Translation {
  controlId: number;

  languageId: number;

  name: string;

  description?: string;

  background?: string;

  implementation?: string;

  outOfScopeReason?: string;

  lang?: Language;

  constructor() {
    this.controlId = 0;
    this.languageId = 0;
    this.name = '';
  }
}
